import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';

const url = process.env.REACT_APP_APPROVAL_URL;
const url2 = process.env.REACT_APP_POST_APPROVAL_URL;

export const GetAllRequest = async (setData,filterData,Page,setIsLoading,status) => {
  let filter={};
  console.log(filterData);

  if(filterData&&filterData.date&&filterData.date!==''){
    filter['date'] = filterData.date;
  }
  if(filterData&&filterData.name&&filterData.name!==''){
    filter['agent_name'] = filterData.name;
  }
  if(filterData&&filterData.agent_code&&filterData.agent_code!==''){
    filter['agent_code'] = filterData.agent_code;
  }
  if(filterData&&filterData.state&&filterData.state!==''&&filterData.state!=='select'){
    filter['state'] = filterData.state;
  }
  if(filterData&&filterData.district&&filterData.district!==''&&filterData.district!=='select'){
    filter['district'] = filterData.district;
  }
  if(filterData&&filterData.bank&&filterData.bank!==''&&filterData.bank!=='select'){
    filter['bank_name'] = filterData.bank;
  }

  try {
    setIsLoading(true)
    await axios
      .get(`${url2}/products/kiosk_status`, {
        params:{...filter,page:Page,status:status},
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
            setIsLoading(false)

        setData(res.data);
      })
      .catch((err) => {
            setIsLoading(false)

        console.log(err);
        console.clear();
      });
  } catch (error) {
    // console.log(error);
        setIsLoading(false)

    console.clear();
    TokenLogout(error);
  }
};

export const GetAllRequestForFilter = async (setData,filterData,setMessage,handleAlertOpen,setSeverity,setIsLoading,status) => {
  let filter={};
  console.log(filterData);

  if(filterData&&filterData.date&&filterData.date!==''){
    filter['date'] = filterData.date;
  }
  if(filterData&&filterData.name&&filterData.name!==''){
    filter['agent_name'] = filterData.name;
  }
  if(filterData&&filterData.agent_code&&filterData.agent_code!==''){
    filter['agent_code'] = filterData.agent_code;
  }
  if(filterData&&filterData.state&&filterData.state!==''&&filterData.state!=='select'){
    filter['state'] = filterData.state;
  }
  if(filterData&&filterData.district&&filterData.district!==''&&filterData.district!=='select'){
    filter['district'] = filterData.district;
  }
  if(filterData&&filterData.bank&&filterData.bank!==''&&filterData.bank!=='select'){
    filter['bank_name'] = filterData.bank;
  }
  try {
    setIsLoading(true)
    await axios
      .get(`${url2}/products/kiosk_status`, {
        params:{...filter,page:1,status:status},
        headers: {
          'Content-Type': 'application/json',
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        setIsLoading(false)
        setData(res.data);
      })
      .catch((err) => {
        setIsLoading(false)
        console.log(err);
        console.clear();
      });
  } catch (error) {
    // console.log(error);
    console.clear();
    setIsLoading(false)
    setMessage(error.response?error.response.data.error:"Something went wrong");
    handleAlertOpen(true);
    setSeverity('error');
    TokenLogout(error);


  }
};




export const GetAllRequestAtKycUpload = async (setData,setIsLoading,Page,status) => {

    try {
        setIsLoading(true)
        await axios.get(`${url2}/products/kyc_approve`,{
            headers: {
                'Content-Type': 'application/json',
                Authorization:`Bearer ${sessionStorage.getItem('token')}`
            },
            params:{
              page:Page,
              status:status
              // limit:10
            }
        })
            .then((res) => {
                setData(res.data);
                setIsLoading(false)
            })
            .catch((err) => {
                console.log(err);
                console.clear();
                setIsLoading(false)
            })
    } catch (error) {
        console.log(error);
        console.clear();
        TokenLogout(error)
        setIsLoading(false)
    }
}

export const GetRequestById = async (setData, userId,setIsLoading) => {

    try {
        setIsLoading(true)
        await axios.post(`${url}/kiosk_details`, { user_id: userId },{
            headers:{
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('token')}`
            },
        })
            .then((res) => {
                setData(res.data);
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false)
                console.log(err);
                console.clear();
            })
    } catch (error) {
        // console.log(error);
        setIsLoading(false)
        TokenLogout(error)
        console.clear();
    }
}

export const GetFieldDataFromKyc = async (setData, dummy, id, setIsLoading) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/finvesta_user_product_details`,
        {
          data_required: dummy,
          user_id: id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        setData(res.data);
      })
      .catch((err) => {
        // console.log(err);

        setIsLoading(false);
        TokenLogout(err)
        console.log(err);
        // console.clear();
      });


  } catch (error) {
    setIsLoading(false);
    // console.log(error);
    TokenLogout(error);
    // console.clear();
  }
};

export const GetFieldData = async (setData, dummy, id) => {
  try {
    // setIsLoading(true)
    await axios
      .post(
        `${url}/finvesta_user_product_details`,
        {
          data_required: dummy,
          user_id: id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        // setIsLoading(false)
        setData(res.data);
      });
  } catch (error) {
    // setIsLoading(false)
    // console.log(error);
    TokenLogout(error);
    // console.clear();
  }
};

export const GetFieldDataWithLoader = async (setData, dummy, id,setIsLoading) => {
  try {
    setIsLoading(true)
    await axios
      .post(
        `${url}/finvesta_user_product_details`,
        {
          data_required: dummy,
          user_id: id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false)
        setData(res.data);
      });
  } catch (error) {
    setIsLoading(false)
    // console.log(error);
    TokenLogout(error);
    // console.clear();
  }
};

export const GetFieldPendingData = async (setData, dummy, id,setIsLoading) => {
  try {
    setIsLoading(true)
    await axios
      .post(
        `${url}/finvesta_user_product_details`,
        {
          data_required: dummy,
          user_id: id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false)
        setData(res.data);
      });
  } catch (error) {
    setIsLoading(false)
    // console.log(error);
    TokenLogout(error);
    console.clear();
  }
};

export const GetExcelData = async (setExcelUserData, proid, id) => {
  try {
    // setIsLoading(true)
    await axios
      .post(
        `${url2}/products/finvesta_user_data_excel_download`,
        {
          product_id: proid,
          user_id: id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        // setIsLoading(false)
        setExcelUserData(res.data);
      });
  } catch (error) {
    // setIsLoading(false)
    // console.log(error);
    TokenLogout(error);
    console.clear();
  }
};

export const GetFieldDataArray = async (dummy, id) => {
  try {
    // setIsLoading(true)
    await axios
      .post(
        `${url}/finvesta_user_product_details`,
        {
          data_required: dummy,
          user_id: id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        // setIsLoading(false)
        return res.data[0][dummy[0]];
      });
  } catch (error) {
    // setIsLoading(false)
    // console.log(error);
    TokenLogout(error);
    console.clear();
  }
};

// changes

export const ProvideApproval = async (
  postData,
  setData,
  handleClose,
  setAlertMessage,
  handleAlertOpen,
  setAlertType,
  setDisableButtons
) => {
  // console.log("PostData api ", postData);
  try {
    setDisableButtons(true);
    if (
      sessionStorage.getItem('UserType') === 'tm' ||
      sessionStorage.getItem('UserType') === 'sh' ||
      sessionStorage.getItem('UserType') === 'rm'
    ) {
      await axios
        .post(`${url2}/products/approve`, postData, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        })
        .then((response) => {
          setAlertMessage(response.data.message);
          setAlertType('success');
          handleAlertOpen();

          setTimeout(() => {
            window.location.reload();
            GetAllRequest(setData,null,1,setDisableButtons,"pending");
            handleClose();
            setDisableButtons(false);
          }, 2000);
        });
    } else if (sessionStorage.getItem('UserType') === 'ops') {
      await axios
        .post(`${url2}/products/ops/approve`, postData, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        })
        .then((response) => {
          setAlertMessage(response.data.message);
          setAlertType('success');
          handleAlertOpen();
          setDisableButtons(false);
          setTimeout(() => {
            GetAllRequest(setData,null,1,setDisableButtons,"pending");
            handleClose();
          }, 1500);
        });
    }
    else if(sessionStorage.getItem('UserType') === 'aec_admin'){
      await axios
       .post(`${url2}/products/aec_admin/approve`, postData, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        })
       .then((response) => {
          setAlertMessage(response.data.message);
          setAlertType('success');
          handleAlertOpen();
          setDisableButtons(false);
          setTimeout(() => {
            GetAllRequest(setData,);
            handleClose();
          }, 1500);
        });
    }
  } catch (error) {
    // console.log(error);
    setAlertMessage(error.response &&error.response.data.error&&typeof error.response.data.error==='string'?error.response.data.error:  'Something went wrong');
    setAlertType('error');
    handleAlertOpen();
    setDisableButtons(false);
    console.clear();
    TokenLogout(error);
  }
};

export const getImages = async (imageUrl, setImageFile, handleImageOpen, handleOpenAlert, handleOpen, handleClose, setFileType) => {
  try {
    handleOpen();
    await axios
      .post(
        `${url}/download`,
        { url: imageUrl },
        {
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        handleClose();
        const contentType = response.headers['content-type'];

        if (response.status === 200) {
          console.log('', response);
          handleImageOpen();
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          });
          const imageUrl = URL.createObjectURL(blob);
          if (contentType === 'application/pdf') {
            handleImageOpen();
            setImageFile(imageUrl);
            setFileType('pdf');
          } else if (contentType.startsWith('image/')) {
            handleImageOpen();
            setImageFile(imageUrl);
            setFileType('image');
          } else {
            fileExtension = `$file.bin`;
          }
        }
      });
  } catch (error) {
    // console.log(error);
    handleClose();
    handleOpenAlert();
    TokenLogout(error);
  }
};

export const getImagesCSPkyc = async (imageUrl, setImageFile, handleImageOpen, handleOpenAlert, setFileType, setIsLoading) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/download`,
        { url: imageUrl },
        {
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        const contentType = response.headers['content-type'];
        setIsLoading(false);
        if (response.status === 200) {
          console.log(response);
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          });
          const imageUrl = URL.createObjectURL(blob);

          if (contentType === 'application/pdf') {
            handleImageOpen();
            setImageFile(imageUrl);
            setFileType('pdf');
          } else if (contentType.startsWith('image/')) {
            handleImageOpen();
            setImageFile(imageUrl);
            setFileType('image');
          } else {
            fileExtension = `${name}.bin`;
          }
        }
      });
  } catch (error) {
    // console.log(error);
    setIsLoading(false);
    handleOpenAlert();
    TokenLogout(error);
  }
};




export const getImagesCSP = async (imageUrl, setImageFile, handleImageOpen, handleOpenAlert, setFileType) => {
  try {
    await axios
      .post(
        `${url}/download`,
        { url: imageUrl },
        {
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        const contentType = response.headers['content-type'];
        if (response.status === 200) {
          console.log(response);
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          });
          const imageUrl = URL.createObjectURL(blob);

          if (contentType === 'application/pdf') {
            handleImageOpen();
            setImageFile(imageUrl);
            setFileType('pdf');
          } else if (contentType.startsWith('image/')) {
            handleImageOpen();
            setImageFile(imageUrl);
            setFileType('image');
          } else {
            fileExtension = `${name}.bin`;
          }
        }
      });
  } catch (error) {
    // console.log(error);
    handleOpenAlert();
    TokenLogout(error);
  }
};

export const DownloadImages = async (imageUrl, name, handleOpenAlert, handleOpen, handleClose) => {
  try {
    handleOpen();
    await axios
      .post(
        `${url}/download`,
        { url: imageUrl },
        {
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        handleClose();
        if (response.status === 200) {
          console.log(response.data);
          const contentType = response.headers['content-type'];
          const blob = new Blob([response.data], { type: contentType });

          let fileExtension = name;
          if (contentType === 'application/pdf') {
            fileExtension = `${name}.pdf`;
          } else if (contentType.startsWith('image/')) {
            fileExtension = `${name}.jpg`;
          } else {
            fileExtension = `${name}.bin`;
          }
          const imageUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = imageUrl;
          a.download = fileExtension;
          a.click();
          URL.revokeObjectURL(imageUrl);
        }
      });
  } catch (error) {
    handleClose();
    // console.log(error);
    handleOpenAlert();
    // console.clear();
    TokenLogout(error);
  }
};

export const DownloadImages2 = async (imageUrl, name, handleOpenAlert ,setIsLoading) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/download`,
        { url: imageUrl },
        {
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        setIsLoading(false);
        if (response.status === 200) {
          console.log(response.data);
          const contentType = response.headers['content-type'];
          const blob = new Blob([response.data], { type: contentType });

          let fileExtension = name;
          if (contentType === 'application/pdf') {
            fileExtension = `${name}.pdf`;
          } else if (contentType.startsWith('image/')) {
            fileExtension = `${name}.jpg`;
          } else {
            fileExtension = `${name}.bin`;
          }
          const imageUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = imageUrl;
          a.download = fileExtension;
          a.click();
          URL.revokeObjectURL(imageUrl);
        }
      });
  } catch (error) {
    setIsLoading(false);
    // console.log(error);
    handleOpenAlert(error.response&&error.response.error?error.ersponse.error:"Something went wrong","error");
    // console.clear();
    TokenLogout(error);
  }
};

export const getImages2 = async (imageUrl, setImageFile, setImageType, handleImageOpen, setLoading) => {
  try {
    setLoading(true);
    await axios
      .post(
        `${url}/download`,
        { url: imageUrl },
        {
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          handleImageOpen();
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          });
          const imageUrl = URL.createObjectURL(blob);
          setImageFile(imageUrl);
          setImageType(response.headers['content-type']==="application/pdf"?"pdf":"img")
        }
      });
  } catch (error) {
    console.log(error);
    setLoading(false);
    // console.clear();
    TokenLogout(error);
  }
};

export const SendReuploadRequest = async (field, displayname, userid, handleOpen, handleClose, handleOpenAlert) => {
  try {
    handleOpen();
    await axios
      .post(
        `${url2}/products/finvesta_user_document_reupload`,
        {
          user_id: userid,
          doc_key: field,
          doc_name: displayname
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        handleClose();
        handleOpenAlert(res.data.message, 'success');
      });
  } catch (error) {
    handleClose();
    handleOpenAlert(error&&error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error");
    console.log(error);
    console.clear();
    TokenLogout(error);
  }
};

export const SendReuploadFile = async (
  file,
  filename,
  userId,
  setAlertMessage,
  setAlertType,
  handleOpen,
  getFieldValue,
  setIsLoading,
  setPostData,
  PostData,
  handleCloseLiveCapture
) => {
  try {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user_id', userId);

    await axios
      .post(`${url2}/products/finvesta_user_file_upload/${filename}`, formData, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        setIsLoading(false);
        console.log(res);
        setAlertMessage('File uploaded successfully');
        setPostData({ ...PostData, [filename]: file });
        setAlertType('success');
        handleOpen();
        setTimeout(() => {
          getFieldValue();
          handleCloseLiveCapture()
        }, 1000);
      });
  } catch (error) {
    setIsLoading(false);
    console.log(error);
    TokenLogout(error);
    setAlertMessage(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setAlertType('error');
    handleOpen();
  }
};



export const SendReuploadFileCspList = async (
  file,
  filename,
  userId,
  handleAlertOpen,
  getFieldValue,
  setIsLoading,

) => {
  try {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user_id', userId);

    await axios
      .post(`${url2}/products/finvesta_user_file_upload/${filename}`, formData, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        setIsLoading(false);
        console.log(res);
        handleAlertOpen(res.data.message,"success")
        setTimeout(() => {
          getFieldValue();
        }, 1000);
      })
      .catch((error=>{
        setIsLoading(false);
        // console.log(error);
        TokenLogout(error);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong!!!',"error");
      }))
  } catch (error) {
    setIsLoading(false);
    console.log(error);
    TokenLogout(error);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong!!!',"error");

  }
};

export const ApproveReuploadRequest = async (userId, productId, Postdata, setAlertMessage, setAlertType, handleClick, setIsLoading) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url2}/products/finvesta_user_file_approve`,
        {
          user_id: userId,
          product_id: productId,
          kiosk_data: Postdata
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        // console.log(res);
        setIsLoading(false);
        setAlertMessage(res.data ? res.data.message : 'Request approved successfully');
        setAlertType('success');
        handleClick();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
  } catch (error) {
    // console.log(error);
    setIsLoading(false);
    setAlertMessage(
      error.response ? (error.response.data.error ? error.response.data.error : 'Something went wrong') : 'Something went wrong'
    );
    TokenLogout(error);
    setAlertType('error');
    handleClick();
    console.clear();
  }
};
